import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { SuccessIcon, RemoveIcon, MinusIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationLabelIcon = ({
  status
}) => {
  switch (status) {
    case 'PASSED':
      return /*#__PURE__*/_jsx(IconCircle, {
        borderStyle: "none",
        padding: "100",
        size: "200",
        icon: SuccessIcon,
        color: "icon-info-on-fill-default",
        backgroundColor: "fill-positive-default"
      });
    case 'FAILED':
      return /*#__PURE__*/_jsx(IconCircle, {
        borderStyle: "none",
        padding: "100",
        size: "200",
        icon: RemoveIcon,
        color: "icon-info-on-fill-default",
        backgroundColor: "fill-alert-default"
      });
    case 'NOT_APPLICABLE':
      return /*#__PURE__*/_jsx(IconCircle, {
        borderStyle: "none",
        padding: "100",
        size: "200",
        icon: MinusIcon,
        color: "icon-info-on-fill-default",
        backgroundColor: "icon-primary-disabled"
      });
    default:
      return null;
  }
};
export default ValidationLabelIcon;